import { IdentificationIcon, UserIcon } from '@heroicons/react/24/outline'
import { Navigate, Route, Routes } from 'react-router-dom'
import { RouteElement } from '../../../interfaces/_common'
import { SubMenuTabs } from '../common'
import { Roles } from './Roles'
import { UsersList } from './Users'
import { LoginActivity } from './LoginActivity'
import { hasAccess } from 'constants/permission.utils'
import { useAuth } from 'context/authContext'
import { Unauthorized } from 'containers/Unauthorized'
import RouteKeys from 'constants/route-keys'

const _routes: RouteElement[] = [
    {
        route: 'users',
        title: 'Users',
        component: UsersList,
        icon: UserIcon,
        display: true,
        key : RouteKeys.ADMIN_USER
    },
    {
        route: 'roles',
        title: 'Roles',
        component: Roles,
        icon: IdentificationIcon,
        display: true,
        key : RouteKeys.ROLE
    },
    // {
    //     route: 'login-activity',
    //     title: 'Login Activity',
    //     component: LoginActivity,
    //     icon: UserIcon,
    //     display: true
    // },
]
const AdminManagement = () => {
    const auth = useAuth()
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {_routes.map((route) =>
                        hasAccess(route.key, auth?.user?.permissions) ? (
                            <Route
                                key={route.key}
                                path={`${route.route}${
                                    route.hasChild ? '/*' : ''
                                }`}
                                element={<route.component />}
                            />
                        ) : (
                            <Route
                                key={route.key}
                                path={route.route}
                                element={<Unauthorized />}
                            ></Route>
                        )
                    )}
                </Routes>
            </div>
        </div>
    )
}

export default AdminManagement
